import firebase from 'firebase/app';
import 'firebase/firestore';

class NotificationService {
    #_fr = firebase.firestore();

    async _getTokens(type: string): Promise<String[]> {
        var reference = this.#_fr.collection("users");

        if (type === "DRIVER") {
            return (await reference.where("role", "==", "DRIVER").get()).docs.map<String>(element => {
                const doc = element.data();
                return doc.fcmToken || "";
            });
        } else if (type === "DELIVERY") {
            return (await reference.where("role", "==", "DELIVERY").get()).docs.map<String>(element => {
                const doc = element.data();
                return doc.fcmToken || "";
            });
        }


        return (await reference.get()).docs.map<String>(element => {
            const doc = element.data();
            return doc.fcmToken || "";
        });
    }

    async sendPush(type: string, title: string, description: string) {
        const tokens: String[] = await this._getTokens(type);
        const path = "https://fcm.googleapis.com/fcm/send";
        const accessToken = "AAAAU29_K5o:APA91bGVak6a8zYsOSAfUa-crCHPDkyG-Q_hy7LE8EiumqqBxgOkmpIPSs2O6DAEmPmvG-4qsRQf5pf2jvOR5IYv4OM8v4RFC-AgVOB1Yi7mwyF4_RneulgQ6oqnTBswGGLx0vM3NJ47";

        await fetch(path, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'key=' + accessToken,
            },
            body: JSON.stringify({
                data: {
                    title,
                    body: description,
                },
                registration_ids: tokens,
            }),
        });
    }
}

export default NotificationService;